import { getAIToken } from "@/api";

export default {
  namespaced: true,
  state: {
    AIToken: "",
  },
  mutations: {
    setAIToken(state, val) {
      state.AIToken = val;
    },
  },
  actions: {
    async getAITokenData(context) {
      try {
        const res = await getAIToken();
        if (res.code == 200) {
          context.commit("setAIToken", res.data.access_token);
        }
      } catch (error) {}
    },
  },
};
